import { IncomeStatus } from "shared/types";
import { toMoney } from "shared/utils";
import { Stat } from "views/applications-id-report/components/Stat";
import { mapIncomeSourceStatus } from "views/applications-id-report/slices/CombinedIncomeReportSlice/helpers";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";
import {
  getIncomeActualNetAndGrossDollars,
  getMonthlyAmount
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";

export const IncomeStats = ({
  income,
  currentItem
}: {
  income: CombinedIncome;
  currentItem?: VerifiedItem | VerifiedItem[];
}) => {
  const { status } = mapIncomeSourceStatus(income);
  const isRejected = status === "Rejected";
  const isProcessing = income.status === IncomeStatus.Processing;
  const { actualVerifiedNetMonthlyDollars, actualVerifiedGrossMonthlyDollars } =
    getIncomeActualNetAndGrossDollars(income, currentItem);

  return (
    <div className="flex items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 flex-1">
        <Stat
          title="Verified gross monthly"
          value={
            (isRejected && !actualVerifiedGrossMonthlyDollars) || isProcessing
              ? "-"
              : toMoney(actualVerifiedGrossMonthlyDollars)
          }
        />
        <Stat
          title="Verified net monthly"
          value={
            (isRejected && !actualVerifiedNetMonthlyDollars) || isProcessing
              ? "-"
              : toMoney(actualVerifiedNetMonthlyDollars)
          }
        />
        <Stat
          title="Self-reported gross monthly"
          value={toMoney(
            getMonthlyAmount(income.amount_cents, income.pay_period) / 100
          )}
        />
      </div>
    </div>
  );
};
